/**
 * Test IDs for QA automation.
 */
export const testIds = {
  organizationDocumentsManagementShowDocument: "organization-documents-management-show-document",
  organizationDocumentsManagementEditDocument: "organization-documents-management-edit-document",
  organizationDocumentsManagementDeleteDocument: "organization-documents-management-delete-document",
  organizationDocumentsManagementAddDocument: "organization-documents-management-add-document",
} as const;
